import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CfmViewFormService } from 'src/app/services/cfm-view-form.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-cfm-model',
  templateUrl: './cfm-model.component.html',
  styleUrls: ['./cfm-model.component.scss']
})
export class CfmModelComponent implements OnInit {
  @Input('customerExperience') customerExperience: any = '';
  @Input('cfmSurveydata') cfmSurvey: any = '';
  @Input('surveyQuestions') surveyQuestions: any[] = [];
  @Input('answers') answers: any[] = [];

  surveyGuid: any = '';
  customerEffort: any = '';
  customerAnswer: any = '';
  customerAnswerMulti: any[] = [];
  customerReasonComments: any = '';
  showQuestions: boolean = false;
  feedbackSuccess: boolean = false;
  showComments: boolean = false;
  selectedRating: any = '';
  selectedQuestions: any[] = [];

  constructor(private CFMS: CfmViewFormService,
    private modalController: ModalController,
    private UTS: UtilitiesService,
    private translate: TranslateService) {

  }

  ngOnInit() {

    if (this.customerExperience && this.customerExperience !== "") {
      let questions = this.surveyQuestions[0];
      questions?.answers?.option.forEach(element => {
        if (element?.optionGUID === this.customerExperience) {
          this.clickCustomerExperience(this.customerExperience, questions.backendId);
        }

      });
    }
  }

  clickCustomerExperience(experienceGuid, questionGuid) {
    this.customerExperience = experienceGuid
    this.answers[0] = {
      "questionGuid": questionGuid,
      "answerGuid": experienceGuid
    };
    this.surveyQuestions[0].answers?.option?.forEach(option => {
      if (this.customerExperience == option.optionGUID) {
        this.selectedRating = option.rating;
      }
    });
    this.surveyQuestions[2].answers?.option?.forEach(option => {
      if (this.selectedRating < 4 && option.title == 'predefinedTextForLowRating') {
        this.selectedQuestions = option.option;
      } else if (this.selectedRating > 3 && option.title == 'predefinedTextForHighRating') {
        this.selectedQuestions = option.option;
      }
    });

  }

  clickCustomerEffort(effortGuid, questionGuid) {
    this.customerEffort = effortGuid
    this.answers[1] = {
      "questionGuid": questionGuid,
      "answerGuid": effortGuid
    };
    this.showQuestions = true;
  }
  clickCustomerAnswer(answerGuid, answerTitle, questionGuid) {
    var exist = false;
    var answerGuidOrText = (answerGuid != null && answerGuid != '') ? true : false;
    if (this.surveyQuestions[2].answers.answerType == 'multiSelect') {
      if (this.customerAnswerMulti.length > 0) {

        this.customerAnswerMulti.forEach(function (answer, key) {
          if ((answer == answerTitle) || (answer == answerGuid)) {
            exist = true;
            this.customerAnswerMulti.splice(key, 1);
          }
        });
        if (answerGuidOrText) {
          this.customerAnswerMulti.push(answerGuid);
        } else {
          this.customerAnswerMulti.push(answerTitle);
        }
      } else {
        this.customerAnswerMulti.push((answerGuid != null && answerGuid != '') ? answerGuid : answerTitle);
      }
      if (answerTitle == 'Other' || answerTitle == this.translate.instant('OTHER')) {
        this.showComments = true;

        this.answers[2] = {
          "questionGuid": questionGuid,
          "answerGuid": "",
          "comment": this.customerAnswerMulti.toString()
        };
      } else {
        this.showComments = false;
        if (answerGuidOrText) {
          this.answers[2] = {
            "questionGuid": questionGuid,
            "answerGuid": this.customerAnswerMulti.toString(),
            "comment": answerTitle
          };
        } else {
          this.answers[2] = {
            "questionGuid": questionGuid,
            "answerGuid": "",
            "comment": this.customerAnswerMulti.toString()
          };
        }
      }

    } else if (this.surveyQuestions[2].answers.answerType == 'text') {
      if (answerTitle == 'Other' || answerTitle == this.translate.instant('OTHER')) {
        this.showComments = true;
        this.customerAnswer = answerTitle
        this.answers[2] = {
          "questionGuid": questionGuid,
          "answerGuid": "",
          "comment": answerTitle
        };
      } else {
        this.showComments = false;
        if (answerGuid != null && answerGuid != '') {
          this.customerAnswer = answerGuid
          this.answers[2] = {
            "questionGuid": questionGuid,
            "answerGuid": answerGuid,
            "comment": answerTitle
          };
        } else {
          this.customerAnswer = answerTitle
          this.answers[2] = {
            "questionGuid": questionGuid,
            "answerGuid": "",
            "comment": answerTitle
          };
        }
      }
    }
  }

  closeModel(resposne) {
    this.showQuestions = false;
    this.customerEffort = null;
    this.customerAnswer = '';
    this.modalController.dismiss(resposne);
  }
  submitFeedback() {
    this.answers[2].comment = this.answers[2].comment + "," + this.customerReasonComments;

    var request = {
      "feedback": {
        "browserInfo": this.UTS.getBrowserInfo(),
        "language": this.UTS.getLocaleLanguage().toString().toLocaleUpperCase(),
        "surveyGuid": "9e4-b515de8da5e0",
        "answers": []
      }
    }
    request.feedback.answers = this.answers;
    this.CFMS.sendCFM(request).subscribe(response => {
      this.UTS.createCookie("cfm", "true", 30);
      this.closeModel(true);
    }, (e) => {
      this.closeModel(false);
    });

  }
  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
